import { useAuth } from "@/contexts/AuthContext";
import { submitSurvey } from "@/services/generatedAPIs";
import { SurveyItem, UserInfoResponseRole } from "@/services/generatedAPIs.schemas";
import { useEffect, useState } from "react";
import { WithTranslation, withTranslation } from "react-i18next";
import { toast } from "sonner";

function Survey({
    t,
    onSuccess,
    ...props
}: WithTranslation & { onSuccess?: () => void }) {
    const { getCurrentUser } = useAuth();

    const questions = [
        { id: 1, text: "1. 知道自己的優點。" }, 
        { id: 2, text: "2. 當我的感受讓我難以專注時，我可以察覺到。" }, 
        { id: 3, text: "3. 辨識自己的情緒。" },
        { id: 4, text: "4. 知道讓自己冷靜下來的方法。" },
        { id: 5, text: "5. 向與自己觀點不相同的人學習。" },
        { id: 6, text: "6. 通過觀察其他人的面部表情，大概知道他們當時的感受。" },
        { id: 7, text: "7. 知道別人在什麼時候需要幫忙。" },
        { id: 8, text: "8. 即使當時感到受挫，我仍堅持完成某件事情。" },
        { id: 9, text: "9. 即使當時非常興奮，我依然保持耐性。" },
        { id: 10, text: "10. 即使任務對我來說困難，我仍能堅持完成。" },
        { id: 11, text: "11. 為自己訂立目標。" },
        { id: 12, text: "12. 即使我不想做功課，我依然會完成。" },
        { id: 13, text: "13. 為測驗做好準備。" },
        { id: 14, text: "14. 在意見不合時，尊重同學的觀點。" },
        { id: 15, text: "15. 友好地與同學相處。" },
        { id: 16, text: "16. 思考做出某個選擇後可能發生的事情。" },
        { id: 17, text: "17. 知道什麼是對的，什麼是錯的。" },
    ];

    const [ answers ] = useState<SurveyItem[]>(new Array(questions.length));
    const [ startTime, setStartTime ] = useState<Date>();

    useEffect(() => {
        setStartTime(new Date());
    }, []);

    return (
        <div className="fixed inset-0 bg-black/50 z-50 flex items-center justify-center p-6">
                <div className="bg-white/80 bg-gradient-to-br from-blue-50 to-blue-100 rounded-2xl p-8 shadow-xl w-full max-w-3xl border border-white/50 relative max-h-[90vh] overflow-y-auto">
                    <h2 className="text-2xl font-bold text-slate-700 text-center mb-4">Hi, 同學！為了更好的學習體驗，請填寫以下問卷。填寫完成後即可開始使用本平台。</h2>
                    {/* <p>答題選項：
                        1 = 非常困難；
                        2 = 有啲難；
                        3 = 有啲易；
                        4 = 非常容易;  <span className="text-red-500">*</span> 必須填寫</p> */}

                    {/* explain the meaning of each option */}
                     <h4 className=" font-bold text-slate-700 text-center mb-4">請選擇以下描述對你的難易程度：</h4>
                    <div className="flex gap-6 mt-1 justify-center mb-5 ">
                        <div>
                            <label  className="flex items-center mr-10">
                                <input type="radio"  className="peer hidden" />
                               非常困難  <div className={`w-10 h-10 ml-2 rounded-full flex border items-center justify-center transition transform hover:scale-105 border-2 border-[#e76f51] bg-[#e76f51]`}></div>
                            </label>
                            <p  className="mt-1"></p>
                        </div>
                        <div>
                            <label  className="flex items-center mr-10">
                                <input type="radio"  className="peer hidden" />
                                <div className={`w-10 h-10 rounded-full flex border items-center justify-center transition transform hover:scale-105 border-2 border-[#f4a261] bg-[#f4a261] `}></div>
                            </label>
                            <p className="mt-1"></p>
                        </div>
                        <div>
                            <label  className="flex items-center mr-10">
                                <input type="radio"  className="peer hidden" />
                                <div className={`w-10 h-10 rounded-full flex border items-center justify-center transition transform hover:scale-105 border-2 border-[#e9c46a] bg-[#e9c46a]`}></div>
                            </label>
                            <p className="mt-1"></p>
                        </div>
                        <div>
                            <label  className="flex items-center mr-10">
                                <input type="radio"  className="peer hidden" />
                                <div className={`w-10 h-10 mr-2 rounded-full flex border items-center justify-center transition transform hover:scale-105 border-2 border-[#2a9d8f] bg-[#2a9d8f]`}></div> 非常容易
                            </label>
                            <p className="mt-1"></p>
                        </div>
                    </div>
                    

                    <div  className="mb-2 flex"> 
                        <svg className="w-6 h-6 text-blue-400 dark:text-white" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 20 21">
                            <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M10 3.464V1.1m0 2.365a5.338 5.338 0 0 1 5.133 5.368v1.8c0 2.386 1.867 2.982 1.867 4.175C17 15.4 17 16 16.462 16H3.538C3 16 3 15.4 3 14.807c0-1.193 1.867-1.789 1.867-4.175v-1.8A5.338 5.338 0 0 1 10 3.464ZM4 3 3 2M2 7H1m15-4 1-1m1 5h1M6.54 16a3.48 3.48 0 0 0 6.92 0H6.54Z"/>
                        </svg>
                        <p className="mb-2 ml-2 flex text-blue-400">做你自己，並誠實回答問題。您的私隱非常安全，不會外洩。</p>
                    </div>
                    <form
                        className="space-y-6"
                        onSubmit={(e) => {
                            e.preventDefault();
                            if (answers.length === questions.length && answers.every((value) => !!value.answer)) {
                                submitSurvey({
                                    userId: getCurrentUser()!.id,
                                    userType: getCurrentUser()!.role === UserInfoResponseRole.STUDENT ? 1 : 2,
                                    surveyId: 1,
                                    startTime: startTime!.toISOString(),
                                    submitTime: (new Date()).toISOString(),
                                    items: answers
                                }).then(rsp => {
                                    if (rsp.code === 200 && onSuccess) {
                                        onSuccess();
                                    }
                                }).catch(error => {

                                });
                            } else {
                                toast.error(t('component.needanswer'));
                            }
                            return false;
                        }}
                    >

                        {questions.map((q, index) => (
                            <div key={q.id} className="bg-white rounded-lg shadow p-4 mb-4">
                                <label className="block font-medium text-m text-black">
                                    {q.text} <span className="text-red-500">*</span>
                                </label>

                                <div className="flex gap-6 mt-1 justify-center ">
                                    {/* {[1, 2, 3, 4].map((val) => 
                                    (
                                        <label key={val} className="flex items-center gap-1">
                                            <input type="radio" name={`q${q.id}`} value={val} required onChange={(e) => {
                                                answers[index] = {
                                                    questionId: q.id,
                                                    answer: e.target.value,
                                                    answerAt: (new Date()).toISOString(),
                                                }
                                            }} />{val}
                                        </label>
                                    ))} */}

                                    
                                 
                                    {[1, 2, 3, 4].map((val, optionIndex) => {
                                        const colors = [
                                            "border-2 border-[#e76f51] peer-checked:bg-[#e76f51] peer-checked:text-white",
                                            "border-2 border-[#f4a261] peer-checked:bg-[#f4a261] peer-checked:text-white",
                                            "border-2 border-[#e9c46a] peer-checked:bg-[#e9c46a] peer-checked:text-white",
                                            "border-2 border-[#2a9d8f] peer-checked:bg-[#2a9d8f]  peer-checked:text-white"
                                        ];
                                        return (
                                            <label key={val} className="flex items-center mr-10">
                                                <input
                                                    type="radio"
                                                    name={`q${q.id}`}
                                                    value={val}
                                                    className="peer hidden"
                                                    required
                                                    onChange={(e) => {
                                                        answers[index] = {
                                                            questionId: q.id,
                                                            answer: e.target.value,
                                                            answerAt: new Date().toISOString(),
                                                        };
                                                    }}
                                                />
                                                {/* <span className="p-">{val}</span> */}
                                                {/* <div className={`w-10 h-10 rounded-full flex border items-center justify-center transition transform hover:scale-105 ${colors[optionIndex]}`}>
                                                     <svg
                                                            className="w-5 h-5 opacity-0 scale-0 peer-checked:opacity-100 peer-checked:scale-100 transition " // 这里用 peer-checked 控制显示
                                                            fill="none"
                                                            stroke="red"
                                                            strokeWidth="2"
                                                            viewBox="0 0 24 24"
                                                        >
                                                            <path
                                                            strokeLinecap="round"
                                                            strokeLinejoin="round"
                                                            d="M5 13l4 4L19 7"
                                                            />
                                                        </svg>
                                                </div> */}
                                                <div className={` w-10 h-10 rounded-full flex items-center justify-center border transition-transform hover:scale-105 ${colors[optionIndex]}
                                                    peer-checked:[&>svg]:opacity-100 peer-checked:[&>svg]:scale-100
                                                    `} >
                                                    <svg className="w-8 h-8 opacity-0 scale-95 transition-transform"  fill="none" stroke="white" strokeWidth="2" viewBox="0 0 24 24" aria-hidden="true">
                                                        <path strokeLinecap="round" strokeLinejoin="round" d="M5 13l4 4L19 7" />
                                                    </svg>
                                                </div>
                                                        
                                             
                                                     
                                                
                                            </label>
                                        );
                                    })}
                                </div>
                            </div>
                        ))}

                        <div className="text-center mt-8">
                            <button type="submit" className="bg-blue-500 text-white px-6 py-2 rounded-lg hover:bg-blue-700">
                                提交問卷
                            </button>
                        </div>
                    </form>
                </div>
            </div>
    )
}

export default withTranslation()(Survey);